import { Outlet } from 'react-router-dom'

export function SidebarLayout() {
  return (
    <aside className="twc-flex twc-flex-col twc-items-end twc-gap-4 twc-relative twc-justify-start twc-overflow-hidden xl:twc-max-w-lg twc-max-w-[800px]">
      <Outlet />
    </aside>
  )
}
